export const state = () => ({
	workshops: null,
	cursor: null,
	showWorkshopsLink: true,
});

export const getters = {
	getWorkshops: (state: any) => state.workshops,
	getShowWorkshopsLink: (state: any) => state.showWorkshopsLink,
};

export const mutations = {
	setWorkshops(state: any, payload: any) {
		state.workshops = payload;
	},

	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},

	setShowWorkshopsLink(state: any, payload: any) {
		state.showWorkshopsLink = payload;
	},
};

export const actions = {
	showWorkshopsLink(state: any, payload: any){
		const primaryUniversity = this.$auth.user.universities?.find(
			(u) => u.account.is_primary,
		);
	},

	getWorkshops(state: any) {
		return new Promise((resolve, reject) => {
			let params = {
				cursor: state.state.cursor,
			};

			Object.keys(params).forEach((key) => !params[key] && delete params[key]);

			this.$axios
				.get('/api/workshops', { params })
				.then((res) => {
					let workshops;

					if (state.state.courses) {
						workshops = JSON.parse(JSON.stringify(state.state.workshops));
					}

					if (params.cursor) {
						workshops.data.push(...res.data.data);
						workshops.links = res.data.links;
						workshops.meta = res.data.meta;
					} else {
						workshops = res.data;
					}

					state.commit('setWorkshops', workshops);

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setWorkshops(state: any, payload: any) {
		state.commit('setWorkshops', payload);
	},

	recordsWorkshopView(state: any, workshop_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/workshops/${workshop_uuid}/views`)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	registerToWorkshop(state: any, workshop_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/workshops/${workshop_uuid}/register`)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},
};
